import { GridCellProps } from '@progress/kendo-react-grid';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { getBgColor } from 'src/utils/icons';

const BudgetAmountDollarDisplayCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const { warnings } = dataItem;
  const { displayValue, value } = useGridCellDisplayValue(props);
  const isNull = value === null;
  const formattedValue = !isNull && value !== undefined && value !== '' ? displayValue : '';

  return (
    <GridCellBase
      {...props}
      title={formattedValue}
      style={{
        ...validateNumber(field, dataItem),
      }}
      className={`${getBgColor(
        [],
        warnings?.remainingInitialBudgetAmount as string[]
      )} !text-right`}
      rowSelectionEnabled
    >
      {formattedValue}
    </GridCellBase>
  );
};

export default BudgetAmountDollarDisplayCell;
